import type { Contract } from '@/types/ContractType';

const positive = (value: unknown): number | undefined => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : undefined;
};

/**
 * The purchase price a contract document should print.
 *
 * Buyer-drafted contracts store the price on `offerSpecifics` (which the
 * negotiation/ratification flow keeps current); agent-drafted ones on
 * `agentOfferInfo`. Reading only `agentOfferInfo` printed "N/A" on every
 * buyer draft.
 */
export function getContractOfferPrice(
  contract: Contract | undefined | null
): number | undefined {
  const c = contract as any;
  return (
    positive(c?.offerSpecifics?.offerPrice) ??
    positive(c?.agentOfferInfo?.offerPrice) ??
    positive(c?.offerSpecifics?.purchasePrice) ??
    positive(c?.product?.price)
  );
}
